<script>
	export default {
		name: 'FormExecuter',
		methods: {
			resetForm(formName) {
				const self_ = this;
				const refs_ = self_.$refs;

				let form_;
				
				if(self_.isArray(refs_[formName])) {
					form_ = refs_[formName][0]
				} else {
					form_ = refs_[formName]
				}

				form_.resetValidation()
			}
		}
	}
</script>
